import { useEffect } from 'react';

import validate from './MemberBackgroundCheckFlagValidation';

import { createUsasPersonIfUndefinedOrNull } from '../utils/MemberUtils';

import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';

import useForm from '@usas/ui-web/utils/UseForm';
import ToBoolIfBool from '@usas/ui-web/utils/ToBoolIfBool';
import Constants from '@usas/ui-web/utils/Constants';

const TITLE = 'Background Check Flag';

const useMemberBackgroundCheckFlag = () => {
  const { basePersonState, putBasePerson } = useBasePersonData();
  const { handleSubmit, updateFormState, formState, setFormData, errorState, setErrors }
    = useForm(getInitialFormState(), submitFormCallback, validate);

  const resetForm = () => {
    const setIsDirty = basePersonState.objData.usasPerson ? (basePersonState.objData.usasPerson.bgcFlag === null ? true : false) : true;
    setFormData({
      ...formState,
      bgcFlag: basePersonState.objData.usasPerson ? ToBoolIfBool(basePersonState.objData.usasPerson.bgcFlag) === null ?
        false : ToBoolIfBool(basePersonState.objData.usasPerson.bgcFlag)
        : false,
    }, setIsDirty);
    setErrors({});
  }

  async function submitFormCallback() {
    if (basePersonState.isSaving === false) {
      putBasePerson(basePersonState.objData.personId, createPersonObject());
    }
  }

  function createPersonObject() {
    return {
      ...basePersonState.objData,
      usasPerson: basePersonState.objData.usasPerson
        ? {
          ...basePersonState.objData.usasPerson,
          bgcFlag: formState?.bgcFlag
        }
        : {
          ...createUsasPersonIfUndefinedOrNull(basePersonState.objData.personId),
          bgcFlag: formState?.bgcFlag
        }
    };
  }

  useEffect(() => {
    //Populate formState with data from the getPerson API call
    if (basePersonState.isObjLoaded === true) {
      const setIsDirty = basePersonState.objData.usasPerson ? (basePersonState.objData.usasPerson.bgcFlag === null ? true : false) : true;
      setFormData({
        ...formState,
        bgcFlag: basePersonState.objData.usasPerson ? ToBoolIfBool(basePersonState.objData.usasPerson.bgcFlag) === null ?
          false : ToBoolIfBool(basePersonState.objData.usasPerson.bgcFlag)
          : false,
      }, setIsDirty);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basePersonState]);

  function getInitialFormState() {
    return {
      bgcFlag: false
    };
  }

  return {
    title: TITLE,
    Constants,
    basePersonState,
    formState,
    errorState,
    onFormValueChanged: updateFormState,
    handleSubmit,
    resetForm
  };
};

export default useMemberBackgroundCheckFlag;